import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-mark-logo",
    templateUrl: "./mark-logo.component.html",
    styleUrls: ["./mark-logo.component.scss"]
})
export class FUIMarkLogoComponent {
    @Input() type: "chewzie" | "fedelta" = "fedelta";

    constructor() {}
}
